import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export function fadeInUpGroup() {
  let mm = gsap.matchMedia()

  mm.add('(min-width: 769px)', () => {
    const elementsToAnimate = document.querySelectorAll('[data-animation="fade-in-up-group"]')

    if (elementsToAnimate.length) {
      ScrollTrigger.batch(elementsToAnimate, {
        start: 'top+=200px bottom',
        onEnter: e => {
          gsap.to(e, {
            opacity: 1,
            y: 0,
            duration: 1.2,
            ease: 'power3.out',
            stagger: {
              amount: 0.4
            }
          })
        }
      })
    }
  })
}
